import React from 'react';
import {useTranslation} from '@aboutyou/i18n';
import {Button} from '../Buttons/Button';
import styled from 'styled-components';
import {ErrorBoundaryIconName} from './assets';
import {Text} from '../Text/Text';
import {Icon} from '../Icon/Icon';

interface ErrorPageProps {
  RowComp?: keyof JSX.IntrinsicElements | React.ComponentType<any>;
  headline: string;
  subline?: string | false;
  url?: string;
}

export const ErrorPageInline: React.FC<ErrorPageProps> = ({
  headline,
  RowComp,
  subline,
  url,
}) => {
  const {t} = useTranslation();

  return (
    <>
      <Container>
        <RowContainer as={RowComp}>
          <IconContainer>
            <Icon asset={ErrorBoundaryIconName.FlashWarning} size="XL" />
          </IconContainer>
          <MessageContainer>
            <Text color="Black" size="px18" weight="bold">
              {headline}
            </Text>
            {subline && (
              <Text color="Grey1" size="px14">
                {subline}
              </Text>
            )}
          </MessageContainer>
        </RowContainer>
      </Container>

      {Boolean(url) && (
        <ButtonContainer>
          <Button
            href={url}
            type="primary"
            onClick={() => {
              if (url === window.location.pathname) window.location.href = url;
            }}
          >
            {t('Continue shopping')}
          </Button>
        </ButtonContainer>
      )}
    </>
  );
};

const Container = styled.div`
  padding-top: 30px;
  padding-bottom: 30px;
  background-color: rgba(242, 200, 102, 0.2);
`;

const IconContainer = styled.div`
  margin-right: 20px;
`;

const RowContainer = styled.div`
  justify-content: center;
  display: flex;
  flex: 1;
  align-items: center;
  height: 60px;
`;

const ButtonContainer = styled.div`
  justify-content: center;
  display: flex;
  flex: 1;
  align-items: center;
  margin-top: 30px;
`;

const MessageContainer = styled.div`
  height: 100%;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
`;
